import matrix from '../../data/home_dateimatrix.json'
import matrix_categories from '../../data/home_matrix_categories.json'
import matrix_filenames from '../../data/home_dateinamen.json'

export default function getFunctions(productlist){
    let list = [];
    let tmpList = {};

    productlist.forEach(p => {
        // console.log('parsing p', p, p.product, matrix)
        const found = matrix.filter(i => i.Artikelnummer === p.product)[0];
        // console.log('found', found)
        if (found !== undefined) {
            found.Files.forEach(f => {
                const category = matrix_categories.filter(i => i.files.includes(f))[0];
                if (category) {
                    if (tmpList[category.cat]) {
                        tmpList = {
                            ...tmpList,
                            [category.cat]: {
                                ...tmpList[category.cat],
                                files: [...tmpList[category.cat].files.filter(i => i !== f), f]
                            }
                        };
                    } else {
                        tmpList = {
                            ...tmpList,
                            [category.cat]: {
                                cat: category.cat,
                                files: [f]
                            }
                        };
                    }
                }
            });
        }
    });
    // console.log('tmplist', tmpList)
    Object.keys(tmpList).forEach(key => {
        const cat = tmpList[key];
        const filename = matrix_filenames.filter(i => i.id === cat.cat)[0];
        if (filename) { list.push( filename.file); }
        cat.files.forEach(f => {
            const fname = matrix_filenames.filter(i => i.id === f)[0];
            if (fname) { list.push( fname.file); }
        });
    });
    // console.log('returning', {list, cats: tmpList});
    return {list, cats: tmpList};
}

